export const toTimeInputValue = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return '';
    }

    const match = trimmed.match(/^([0-2]?\d):([0-5]\d)/);
    if (match) {
      const hours = match[1].padStart(2, '0');
      const minutes = match[2];
      return `${hours}:${minutes}`;
    }
  }

  if (value instanceof Date) {
    return value.toISOString().slice(11, 16);
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    const hours = Math.floor(value / 60) % 24;
    const minutes = Math.abs(Math.floor(value % 60));
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  }

  return '';
};

export const normalizeTimeForPayload = (value) => {
  const input = toTimeInputValue(value);
  return input || '';
};

export const formatShiftLabel = (shift) => {
  if (!shift) {
    return '—';
  }

  const start = toTimeInputValue(shift.timeFrom ?? shift.shiftInTime);
  const end = toTimeInputValue(shift.timeTo ?? shift.shiftOutTime);
  const range = start || end ? `${start || '—'} - ${end || '—'}` : null;
  const name = shift.shiftName ? `(${shift.shiftName})` : null;

  if (range && name) {
    return `${range} ${name}`;
  }

  return range || name || '—';
};

